(function () {
  "use strict";

  let isSyncing = false;
  let syncTimer = null;

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncPfand, 120);
  }

  // document.addEventListener("cart:updated", function () {
  //   scheduleSync();
  // });

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function readPfandData() {
    // Blob is re-injected into [data-products] on every buildCart().
    const el = document.querySelector("[data-products] [data-pfand-data]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error("[pfand] Failed to parse data blob:", e);
      return null;
    }
  }

  function rebuildDrawerCart() {
    // Rebuild whichever CartForm instances exist (drawer + page).
    document.dispatchEvent(new CustomEvent("cart:build"));
  }

  function syncPfand() {
    if (isSyncing) return;

    const data = readPfandData();
    if (!data) return;
    if (!data.depositVariantId) return; // setting not configured

    const required = parseInt(data.requiredQty, 10) || 0;
    const current = parseInt(data.depositQty, 10) || 0;

    if (required === current) return; // already correct — terminates the loop

    isSyncing = true;

    // const done = function () {
    //   isSyncing = false;
    //   // Rebuild once more so the corrected line renders. The resulting
    //   // cart:updated will run syncPfand again, find required === current,
    //   // and no-op.
    //   rebuildDrawerCart();
    // };
    const done = function () {
      // Rebuild so the corrected deposit line renders. Release the lock only
      // after the rebuild has had time to paint the fresh blob, so the
      // cart:updated it emits doesn't re-enter against stale data.
      rebuildDrawerCart();
      setTimeout(function () {
        isSyncing = false;
      }, 350);
    };

    const fail = function (err) {
      console.error("[pfand] Sync failed:", err);
      isSyncing = false;
    };

    if (data.depositKey && current > 0) {
      // Deposit already in cart — adjust to required (including removal at 0).
      theme.cart
        .changeItem(data.depositKey, required)
        .then(function (res) {
          const cart = typeof res === "string" ? JSON.parse(res) : res;
          if (cart && cart.status === 422) {
            console.error("[pfand] changeItem rejected:", cart.message);
            isSyncing = false;
            return;
          }
          done();
        })
        .catch(fail);
    } else if (required > 0) {
      // Deposit not in cart — add it via raw add.js (mirrors existing ATC style).
      fetch(getRoot() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: [{ id: data.depositVariantId, quantity: required }] }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (json && json.status && json.status !== 200) {
            console.error("[pfand] add.js rejected:", json.description || json.message);
            isSyncing = false;
            return;
          }
          done();
        })
        .catch(fail);
    } else {
      isSyncing = false;
    }
  }

  // Single trigger path: everything routes through cart:updated.
  document.addEventListener("cart:updated", function () {
    scheduleSync();
  });

  // Initial run on load, in case the cart already holds pfand items
  // (e.g. returning session) but the deposit is missing/stale.
  document.addEventListener("DOMContentLoaded", function () {
    // Defer one tick so the first buildCart() (from CartDrawer.init) has rendered.
    setTimeout(syncPfand, 0);
  });
})();